
    import './styles.scoped.css';
    export default {
  "flash-with-motion": "awsui_flash-with-motion_1q84n_1xld3_97",
  "enter": "awsui_enter_1q84n_1xld3_97",
  "flash-body": "awsui_flash-body_1q84n_1xld3_111",
  "flash-message": "awsui_flash-message_1q84n_1xld3_111",
  "flash-header": "awsui_flash-header_1q84n_1xld3_111",
  "flash-content": "awsui_flash-content_1q84n_1xld3_112",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_1xld3_113",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_1xld3_114",
  "flash-icon": "awsui_flash-icon_1q84n_1xld3_137",
  "entering": "awsui_entering_1q84n_1xld3_150",
  "entered": "awsui_entered_1q84n_1xld3_171",
  "exiting": "awsui_exiting_1q84n_1xld3_276",
  "stack": "awsui_stack_1q84n_1xld3_298",
  "animation-running": "awsui_animation-running_1q84n_1xld3_298",
  "item": "awsui_item_1q84n_1xld3_298",
  "flash-list-item": "awsui_flash-list-item_1q84n_1xld3_299",
  "notification-bar": "awsui_notification-bar_1q84n_1xld3_300",
  "collapsed": "awsui_collapsed_1q84n_1xld3_320",
  "animation-ready": "awsui_animation-ready_1q84n_1xld3_320",
  "expanded-only": "awsui_expanded-only_1q84n_1xld3_320",
  "expanded": "awsui_expanded_1q84n_1xld3_320",
  "flash": "awsui_flash_1q84n_1xld3_97",
  "collapsible": "awsui_collapsible_1q84n_1xld3_384",
  "short-list": "awsui_short-list_1q84n_1xld3_390",
  "visual-refresh": "awsui_visual-refresh_1q84n_1xld3_390",
  "status": "awsui_status_1q84n_1xld3_597",
  "header": "awsui_header_1q84n_1xld3_597",
  "item-count": "awsui_item-count_1q84n_1xld3_598",
  "button": "awsui_button_1q84n_1xld3_599",
  "type-count": "awsui_type-count_1q84n_1xld3_632",
  "count-number": "awsui_count-number_1q84n_1xld3_632",
  "icon": "awsui_icon_1q84n_1xld3_666",
  "floating": "awsui_floating_1q84n_1xld3_707",
  "flashbar": "awsui_flashbar_1q84n_1xld3_715",
  "flash-refresh": "awsui_flash-refresh_1q84n_1xld3_790",
  "flash-list": "awsui_flash-list_1q84n_1xld3_299",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_1xld3_811",
  "flash-text": "awsui_flash-text_1q84n_1xld3_841",
  "dismiss-button": "awsui_dismiss-button_1q84n_1xld3_114",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_1xld3_883",
  "action-button": "awsui_action-button_1q84n_1xld3_113",
  "action-slot": "awsui_action-slot_1q84n_1xld3_893",
  "flash-type-success": "awsui_flash-type-success_1q84n_1xld3_897",
  "flash-type-error": "awsui_flash-type-error_1q84n_1xld3_901",
  "flash-type-info": "awsui_flash-type-info_1q84n_1xld3_905",
  "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_1xld3_906",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_1xld3_910"
};
  